import { prisma } from "@/lib/db";
import { CategoryRow, CategoryCreateForm } from "./_form";

export const dynamic = "force-dynamic";

export default async function CategoriesAdminPage() {
  const cats = await prisma.category.findMany({
    orderBy: [{ order: "asc" }, { name: "asc" }],
    select: {
      id: true,
      slug: true,
      name: true,
      description: true,
      order: true,
      metaTitle: true,
      metaDesc: true,
      _count: { select: { articles: true } },
    },
  });

  const items = cats.map((c) => ({
    id: c.id,
    slug: c.slug,
    name: c.name,
    description: c.description,
    order: c.order,
    metaTitle: c.metaTitle,
    metaDesc: c.metaDesc,
    articleCount: c._count.articles,
  }));

  return (
    <div>
      <div className="flex items-start justify-between gap-4 mb-6">
        <div>
          <h1 className="font-display text-2xl lg:text-3xl font-bold mb-1">Chuyên mục</h1>
          <p className="text-sm text-ink-muted">
            Phân loại bài viết theo chuyên mục. Order quyết định thứ tự hiển thị trong nav/header.
          </p>
        </div>
      </div>

      <CategoryCreateForm />

      <div className="rounded-xl border border-stroke-subtle overflow-hidden">
        <table className="w-full text-sm">
          <thead className="bg-bg-elevated/60 text-left">
            <tr className="border-b border-stroke-subtle">
              <th className="px-4 py-2.5 font-medium text-ink-muted">Tên</th>
              <th className="px-4 py-2.5 font-medium text-ink-muted">Slug</th>
              <th className="px-4 py-2.5 font-medium text-ink-muted">Bài</th>
              <th className="px-4 py-2.5 font-medium text-ink-muted">Order</th>
              <th className="px-4 py-2.5 font-medium text-ink-muted text-right">Hành động</th>
            </tr>
          </thead>
          <tbody>
            {items.length === 0 ? (
              <tr>
                <td colSpan={5} className="px-4 py-8 text-center text-ink-muted text-sm">
                  Chưa có chuyên mục nào.
                </td>
              </tr>
            ) : (
              items.map((c) => <CategoryRow key={c.id} cat={c} />)
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
}
